<template>
  <div class="user-center">
    <div class="topBack">
      <div class="top w1240">
        <span class="avator">
          <img :src="displayUserAvatar" class="avator-img" @mouseenter="handleImgEnter">
        </span>
        <span class="mask" @mouseleave="handleImgLeave" @click="showModal">修改头像</span>
        <div class="box">
          <div class="info">
            <em>{{ userObj.nickname }}</em>
            <span>ID:{{ userObj.studentNumber }}</span>
          </div>
          <p>{{ userObj.sex === 1 ? "女" : "男" }}</p>
        </div>
      </div>
    </div>

    <div class="user-content w1240">
      <ul class="sidebar">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ liActive: liActive === item.id }"
          @click="handleClickLiActive(item)"
        >
          <img :src="liActive === item.id ? item.iconActive : item.icon" alt="">
          <span>{{ item.title }}</span>
        </li>
      </ul>

      <div class="container">
        <div class="tabs" v-if="!isMsgBoard && tabsText.length > 0 && liActive === 8">
          <span
            v-for="(item, index) in tabsText"
            :key="index"
            :class="{ videoActive: tabsActive === index }"
            @click="handleTabsActive(index)"
          >
            <img :src="tabsActive === index ? item.iconBgActive : item.iconBg" class="tabs-img">
            {{ item.label }}
          </span>
        </div>

        <div v-if="liActive === 6">
          <VoteWorks />
        </div>
        <div v-if="liActive === 7">
          <div class="core-content" v-if="tabsActive === 0">
            <FeedBack />
          </div>
        </div>
        <div v-if="liActive === 8">
          <div class="core-content" v-if="tabsActive === 0">
            <Profile :userObj="userObj" />
          </div>
          <div class="core-content" v-if="tabsActive === 1">
            <Pwd :userObj="userObj" />
          </div>
        </div>
        <div v-if="liActive === 9">
          <CompetitionQuery />
        </div>
        <div v-if="liActive === 10">
          <CertificateQuery />
        </div>
      </div>
    </div>

    <a-modal title="上传头像" :visible="visible" :confirm-loading="confirmLoading">
      <div slot="footer" class="avatar-footer-style">
        <div class="btn" @click="handleCancel">取消</div>
        <div class="btn submit" @click="handleOk">确定</div>
      </div>

      <div class="update-avatar">
        <div class="wrap">
          <div class="grid">
            <img :src="displayEditingAvatar" class="grid-img">
          </div>

          <a-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :showUploadList="false"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <div class="btn">重新上传</div>
          </a-upload>
        </div>
        <div class="preview">
          <div class="box">
            <img :src="displayEditingAvatar" class="box-img">
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Profile from "./components/Profile.vue";
import Pwd from "./components/Pwd.vue";
import VoteWorks from "./VoteWorks.vue";
import FeedBack from "./FeedBack.vue";
import CompetitionQuery from "./CompetitionQuery.vue";
import CertificateQuery from "./CertificateQuery.vue";
import { userinfo, userEdit, topicComment } from "@/api/UserCenter";
import { toDisplayImageUrl } from "@/utils/workImage";
import { buildUploadUrl } from "@/utils/uploadUrl";
import cookieStore from "@/utils/store/cookie";

const USER_CENTER_TABS = [
  {
    id: 9,
    title: "大赛查询",
    icon: require("../../assets/user/voteworks.png"),
    iconActive: require("../../assets/user/voteworks1.png"),
  },
  {
    id: 6,
    title: "参赛作品",
    icon: require("../../assets/user/voteworks.png"),
    iconActive: require("../../assets/user/voteworks1.png"),
  },
  {
    id: 10,
    title: "我的证书",
    icon: require("../../assets/user/voteworks.png"),
    iconActive: require("../../assets/user/voteworks1.png"),
  },
  {
    id: 7,
    title: "反馈",
    icon: require("../../assets/user/feetback.png"),
    iconActive: require("../../assets/user/feetback1.png"),
  },
  {
    id: 8,
    title: "设置",
    icon: require("../../assets/img/user/user-8.png"),
    iconActive: require("../../assets/img/user/user-1-active.png"),
    tabsText: [
      {
        label: "个人资料",
        iconBg: require("@/assets/img/user/video.png"),
        iconBgActive: require("@/assets/img/user/video-active.png"),
      },
      {
        label: "修改密码",
        iconBg: require("@/assets/img/user/video.png"),
        iconBgActive: require("@/assets/img/user/video-active.png"),
      },
    ],
  },
];

export default {
  name: "UserCenter",
  components: {
    Profile,
    Pwd,
    VoteWorks,
    FeedBack,
    CompetitionQuery,
    CertificateQuery,
  },
  data() {
    return {
      tabsText: [],
      tabsActive: 0,
      liActive: 9,
      visible: false,
      confirmLoading: false,
      visibleFlag: false,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      defaultAvatar: require("@/assets/img/user.png"),
      tabList: USER_CENTER_TABS,
      userObj: {
        avatar: require("@/assets/img/user.png"),
      },
      userObjAvatar: {
        avatar: require("@/assets/img/user.png"),
      },
      mask: null,
      isMsgBoard: false,
      msgBoardList: [],
      msgBoardInfo: {},
      uploadUrl: buildUploadUrl("/api/upload"),
    };
  },
  computed: {
    uploadHeaders() {
      const token =
        this.$store?.state?.app?.token ||
        cookieStore.get("login_status") ||
        localStorage.getItem("token") ||
        "";
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
    displayUserAvatar() {
      return toDisplayImageUrl(this.userObj.avatar) || this.defaultAvatar;
    },
    displayEditingAvatar() {
      return toDisplayImageUrl(this.userObjAvatar.avatar) || this.defaultAvatar;
    },
  },
  watch: {
    "$route.query.id": {
      immediate: true,
      handler(tabId) {
        const resolvedId = this.resolveTabId(tabId);
        this.applyActiveTab(resolvedId, false);
      },
    },
  },
  mounted() {
    this.userinfoFunc();
    this.mask = document.querySelector(".user-center .mask");
    this.initActive();
  },
  methods: {
    handleSend() {
      this.visibleFlag = true;
    },
    handleMsgBoard(data, status = false) {
      if (status) {
        this.topicCommentFunc(data.id);
        this.msgBoardInfo = data;
      }
    },
    topicCommentFunc(id) {
      const params = {
        discussionTopicId: id,
        limit: 10,
        page: 1,
      };
      topicComment(params)
        .then((res) => {
          this.msgBoardList = res.data;
          this.isMsgBoard = !this.isMsgBoard;
        })
        .catch(() => null);
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      const isLt200M = file.size / 1024 / 1024 < 200;

      if (!isImage) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG、GIF 格式");
      }
      if (!isLt200M) {
        this.$message.error("上传图片大小不能超过 200MB");
      }
      return isImage && isLt200M;
    },
    handleChange(info) {
      if (info.file.status === "done") {
        const imageUrl = info.file.response?.link || null;
        if (imageUrl) {
          this.$message.success("上传成功");
          this.userObjAvatar.avatar = imageUrl;
        } else {
          this.$message.error("上传失败");
        }
      }
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.confirmLoading = true;
      userEdit({
        avatar: this.userObjAvatar.avatar,
        nickname: this.userObjAvatar.nickname,
      })
        .then((res) => {
          if (res.status === 200) {
            this.userinfoFunc();
            this.$message.success("头像修改成功");
            this.visible = false;
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    handleCancel() {
      this.visible = false;
    },
    handleImgEnter() {
      if (this.mask) {
        this.mask.style.display = "block";
      }
    },
    handleImgLeave() {
      if (this.mask) {
        this.mask.style.display = "none";
      }
    },
    userinfoFunc() {
      userinfo({ login: true })
        .then((res) => {
          if (res.status === 200) {
            this.userObjAvatar = JSON.parse(JSON.stringify(res.data));
            this.userObj = JSON.parse(JSON.stringify(res.data));
            localStorage.setItem("nickname", this.userObj.nickname || "");
            this.$store.commit("UPDATE_USERINFO", res.data);
          }
        })
        .catch(() => null);
    },
    initActive() {
      const routeId = Number(this.$route.query.id);
      const savedId = Number(localStorage.getItem("userCenterLiActive"));
      const nextId = this.resolveTabId(routeId || savedId);
      this.applyActiveTab(nextId, !this.$route.query.id);
    },
    resolveTabId(tabId) {
      const targetId = Number(tabId);
      return this.tabList.some((item) => item.id === targetId) ? targetId : 9;
    },
    applyActiveTab(tabId, syncRoute = true) {
      const target = this.tabList.find((item) => item.id === tabId) || this.tabList[0];
      this.liActive = target.id;
      localStorage.setItem("userCenterLiActive", String(target.id));
      this.tabsText = target.tabsText || [];
      if (!target.tabsText) {
        this.tabsActive = 0;
      }
      if (syncRoute && Number(this.$route.query.id) !== Number(target.id)) {
        const nextQuery = {
          ...this.$route.query,
          id: String(target.id),
        };
        if (target.id !== 6) {
          delete nextQuery.activityId;
        }
        this.$router.replace({
          query: nextQuery,
        });
      }
    },
    handleClickLiActive(item) {
      this.applyActiveTab(item.id, true);
    },
    handleTabsActive(index) {
      this.tabsActive = index;
      localStorage.setItem("userCenterTabsActive", index);
    },
  },
};
</script>

<style lang="scss">
.user-center {
  padding-bottom: 20px;
  background-size: 100% 300px;

  .topBack {
    background: #44282f;
  }

  .top {
    height: 200px;
    padding-top: 30px;
    display: flex;
    justify-content: left;
    position: relative;

    .avator {
      width: 186px;
      height: 186px;
      border: 1px solid #999999;
      border-radius: 50%;
      margin-right: 30px;
      background: #fff;
      padding: 3px;
    }

    .avator-img {
      width: 178px;
      height: 178px;
      border-radius: 50%;
      margin-right: 30px;
      object-fit: cover;
    }

    .mask {
      display: none;
      position: absolute;
      left: 0;
      top: 30px;
      width: 186px;
      height: 186px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.54);
      line-height: 186px;
      color: #fff;
      text-align: center;
      font-size: 15px;
      cursor: pointer;
    }

    .info {
      margin: 74px 0 16px;
      line-height: 24px;

      em {
        font-size: 28px;
        color: #fff;
        font-weight: 700;
        margin-right: 10px;
      }

      span {
        display: inline-block;
        line-height: 24px;
        font-size: 14px;
        color: #fff;
        vertical-align: top;
      }
    }

    p {
      line-height: 16px;
      font-size: 16px;
      color: #fff;
      margin: 0;
    }
  }

  .user-content {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;

    .sidebar {
      width: 172px;
      float: left;
      margin-left: -10px;

      li {
        min-height: 48px;
        margin-top: 10px;
        margin-bottom: 16px;
        user-select: none;
        cursor: pointer;
        display: flex;
        justify-content: left;
        align-items: center;
        white-space: nowrap;

        img {
          flex: 0 0 auto;
          width: 25px;
          height: 25px;
          margin-right: 10px;
          margin-left: 15px;
        }

        span {
          display: block;
          flex: 1 1 auto;
          min-width: 0;
          line-height: 1.2;
          font-size: 20px;
          color: #333;
          white-space: nowrap;
        }
      }

      li.liActive {
        background: url("~@/assets/img/user/sidebar-active.svg") no-repeat;
        background-size: 172px 48px;

        span {
          color: #fff;
        }
      }
    }

    .container {
      width: 1025px;

      .tabs {
        height: 47px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        justify-content: left;

        span {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          min-width: 88px;
          line-height: 1;
          font-size: 15px;
          color: #7f7f7f;
          padding: 20px 0 13px;
          margin-right: 34px;
          user-select: none;
          cursor: pointer;
          white-space: nowrap;

          .tabs-img {
            flex: 0 0 auto;
            width: 14px;
            height: 14px;
          }
        }

        span.videoActive {
          color: #da514e;
          border-bottom: 2px solid #da514e;
        }
      }
    }
  }
}

.ant-modal-content {
  border-radius: 18px;
  width: 496px;
}

.ant-modal-header {
  border: none !important;
  padding: 20px 30px !important;
}

.ant-modal-title {
  font-size: 15px !important;
  color: #333 !important;
}

.ant-modal-body {
  padding: 30px 30px 36px;
}

.ant-modal-footer {
  padding: 28px 0 31px !important;
}

.update-avatar {
  display: flex;
  justify-content: space-between;

  .grid {
    width: 300px;
    height: 300px;
    background: url("../../assets/img/user/grid.png") no-repeat;
    background-size: 300px 300px;

    .grid-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .btn {
    margin-top: 18px;
    color: #da514e;
    line-height: 15px;
    font-size: 15px;
    cursor: pointer;
  }

  .preview {
    .box {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background-color: #f2f2f2;

      .box-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.avatar-footer-style {
  display: flex;
  justify-content: center;

  .btn {
    width: 120px;
    height: 36px;
    line-height: 36px;
    margin-left: 20px;
    border: 1px solid #da514e;
    text-align: center;
    color: #da514e;
    border-radius: 5px;
    cursor: pointer;
  }

  .submit {
    background-color: #da514e;
    color: #fff;
  }
}

@media (max-width: 900px) {
  .user-center {
    padding-bottom: 14px;
    background: #f7f8fa;

    .w1240 {
      width: 100%;
      min-width: 0;
    }

    .top {
      height: auto;
      min-height: 118px;
      padding: 18px 16px;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .avator {
        order: 1;
        width: 72px;
        height: 72px;
        margin-right: 0;
        padding: 2px;
      }

      .avator-img {
        width: 66px;
        height: 66px;
        margin-right: 0;
      }

      .box {
        order: 2;
        flex: 1 1 0;
        min-width: 0;
      }

      .mask {
        order: 3;
        display: inline-flex;
        position: static;
        width: auto;
        height: auto;
        margin-left: 84px;
        padding: 7px 12px;
        border-radius: 999px;
        line-height: 1;
        background: rgba(255, 255, 255, 0.16);
        font-size: 12px;
      }

      .info {
        margin: 0 0 8px;
        line-height: 1.4;

        em {
          display: block;
          max-width: 100%;
          margin-right: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 21px;
        }

        span {
          margin-top: 2px;
          font-size: 12px;
        }
      }

      p {
        font-size: 13px;
      }
    }

    .user-content {
      display: block;
      padding: 12px 12px 0;

      .sidebar {
        width: 100%;
        margin: 0;
        display: flex;
        gap: 8px;
        overflow-x: auto;
        padding: 0 0 8px;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          flex: 0 0 auto;
          min-height: 38px;
          margin: 0;
          padding: 0 13px;
          border: 1px solid #eadfd8;
          border-radius: 999px;
          background: #fff;

          img {
            width: 18px;
            height: 18px;
            margin: 0 6px 0 0;
          }

          span {
            font-size: 14px;
          }
        }

        li.liActive {
          background: linear-gradient(90deg, #f3a15d 0%, #ef8f42 100%);
          background-size: auto;
          border-color: transparent;

          span {
            color: #fff;
          }
        }
      }

      .container {
        width: 100%;
        margin-top: 10px;
        padding: 14px 12px 18px;
        border-radius: 16px;
        background: #fff;

        .tabs {
          height: auto;
          overflow-x: auto;
          gap: 18px;
          -webkit-overflow-scrolling: touch;

          span {
            flex: 0 0 auto;
            margin-right: 0;
            padding: 12px 0;
            font-size: 14px;
          }
        }
      }
    }
  }

  .ant-modal {
    width: calc(100vw - 32px) !important;
    max-width: 496px;
  }

  .ant-modal-content {
    width: 100%;
  }

  .ant-modal-body {
    padding: 18px;
  }

  .update-avatar {
    flex-direction: column;
    gap: 18px;

    .grid {
      width: min(260px, 100%);
      height: min(260px, calc(100vw - 72px));
      margin: 0 auto;
      background-size: 100% 100%;
    }

    .preview {
      display: flex;
      justify-content: center;
    }
  }

  .avatar-footer-style {
    padding: 0 16px;
    gap: 10px;

    .btn {
      flex: 1 1 0;
      margin-left: 0;
    }
  }
}
</style>
